// extracted by mini-css-extract-plugin
export var button = "_o9-2";
export var card = "_o9-0";
export var closeButtonContainer = "_o9-3";
export var iconContainer = "_o9-1";